import { RequestHeaderComponent } from '../../request-header/request-header.component';
import { FormGroup, Validators } from '@angular/forms';
import { PmoProgramService } from '../../../shared/services/pmo-program.service';
import { addDays } from 'date-fns';
import { DateService } from '../../../shared/services/date.service';
import { asEnumerable } from 'linq-es2015';
import { ValidatorsService } from '../../../shared/services/validators.service';
import { SettingsService } from 'research.web.settings';
var ExperimentDetailsFormComponent = /** @class */ (function () {
    function ExperimentDetailsFormComponent(pmoProgramService, dateService, validatorsService, settingsService) {
        var _this = this;
        this.pmoProgramService = pmoProgramService;
        this.dateService = dateService;
        this.validatorsService = validatorsService;
        this.settingsService = settingsService;
        this.disableCropSelection = false;
        this.showColdTreatmentInput = false;
        this.showExperimentNameErrorMessages = function () {
            var name = _this.experimentDetailsFormGroup.get("name");
            return name.value && name.invalid && (name.dirty || name.touched);
        };
        this.control = function (controlName) {
            return _this.experimentDetailsFormGroup.get(controlName);
        };
        this.formatOptions = function () {
            _this.ceSites = _this.ceRequestOptions.ceSites
                .filter(function (s) { return s.isActive; })
                .sort(RequestHeaderComponent.selectListSorter)
                .map(function (s) { return ({ id: s.id, display: s.name }); });
            _this.crops = _this.ceRequestOptions.crops
                .filter(function (s) { return s.isActive; })
                .sort(RequestHeaderComponent.selectListSorter)
                .map(function (s) { return ({ id: s.id, display: s.name }); });
            _this.requestPurposes = _this.ceRequestOptions.requestPurposes
                .filter(function (s) { return s.isActive; })
                .filter(function (s) { return _this.currentUser.ceMember || s.name !== 'Donors'; })
                .sort(RequestHeaderComponent.selectListSorter)
                .map(function (c) { return ({ id: c.id, display: c.name }); });
            _this.productConcepts = _this.ceRequestOptions.productConcepts
                .filter(function (c) { return c.isActive; })
                .sort(RequestHeaderComponent.selectListSorter)
                .map(function (c) { return ({ id: c.id, display: c.name }); });
            _this.pmoPrograms = _this.ceRequestOptions.pmoPrograms
                .filter(function (p) { return p.isActive && p.activeProjectCount > 0; })
                .sort(_this.pmoProgramSorter)
                .map(function (p) { return ({ id: p.programKey, display: p.pmoProgramName }); });
            _this.delegates = asEnumerable(_this.ceRequestOptions.users.filter(function (x) { return x.requestMember === true; }))
                .Where(function (u) { return u.ceMember === _this.currentUser.ceMember; })
                .OrderBy(function (u) { return u.surname; })
                .ThenBy(function (u) { return u.givenName; })
                .Select(function (u) {
                return {
                    id: u.id,
                    display: u.givenName + " " + u.surname
                };
            })
                .ToArray();
        };
        this.subscriptions = function () {
            _this.experimentDetailsFormGroup.get('pmoProgram')
                .valueChanges
                .subscribe(function (key) { return _this.onProgramChange(key); });
            _this.experimentDetailsFormGroup.get('crop')
                .valueChanges
                .subscribe(function (d) {
                var packetDate = _this.experimentDetailsFormGroup.get('seedPacketDate');
                packetDate.clearValidators();
                packetDate.setValidators([_this.validatorsService.mustBeOnOrAfterDate(_this.earliestSeedPacketDate), _this.validatorsService.isValidDate, Validators.required]);
                packetDate.updateValueAndValidity();
                if (d == _this.settings.wheatCropId) {
                    _this.showColdTreatmentInput = true;
                    _this.coldTreatmentDays.clearValidators();
                    _this.coldTreatmentDays.setValidators([Validators.required, Validators.min(0)]);
                    _this.coldTreatmentDays.updateValueAndValidity();
                }
                else {
                    _this.showColdTreatmentInput = false;
                    if (_this.coldTreatmentDays) {
                        _this.coldTreatmentDays.clearValidators();
                        _this.coldTreatmentDays.setValue(null);
                    }
                }
            });
            if (_this.coldTreatmentDays) {
                _this.coldTreatmentDays
                    .valueChanges
                    .subscribe(function (d) {
                    var packetDate = _this.experimentDetailsFormGroup.get('seedPacketDate');
                    packetDate.clearValidators();
                    packetDate.setValidators([_this.validatorsService.mustBeOnOrAfterDate(_this.earliestSeedPacketDate), _this.validatorsService.isValidDate, Validators.required]);
                    packetDate.updateValueAndValidity();
                });
            }
            _this.experimentDetailsFormGroup.get('plantingDate')
                .valueChanges
                .subscribe(function (d) {
                var packetDate = _this.experimentDetailsFormGroup.get('seedPacketDate');
                packetDate.clearValidators();
                packetDate.setValidators([_this.validatorsService.mustBeOnOrAfterDate(_this.earliestSeedPacketDate), _this.validatorsService.isValidDate, Validators.required]);
                packetDate.updateValueAndValidity();
            });
        };
        this.earliestPlantingDate = function () {
            var d = _this.dateService.getDateAfterXDays(12);
            var midnight = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
            return midnight;
        };
        this.pmoProgramSorter = function (i1, i2) {
            return i1.pmoProgramName.localeCompare(i2.pmoProgramName);
        };
        this.settings = this.settingsService.get("_appSettings");
    }
    Object.defineProperty(ExperimentDetailsFormComponent.prototype, "selectedCrop", {
        get: function () { return this.experimentDetailsFormGroup.get("crop"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ExperimentDetailsFormComponent.prototype, "plantingDate", {
        get: function () { return this.experimentDetailsFormGroup.get("plantingDate"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ExperimentDetailsFormComponent.prototype, "coldTreatmentDays", {
        get: function () { return this.experimentDetailsFormGroup.get("weeksOfColdTreatment"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExperimentDetailsFormComponent.prototype, "averageDaysForSeedMaturity", {
        get: function () {
            var _this = this;
            if (this.selectedCrop.value)
                return this.ceRequestOptions.crops.find(function (c) { return c.id === _this.selectedCrop.value; }).averageDaysForSeedMaturity;
            else
                return 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExperimentDetailsFormComponent.prototype, "earliestSeedPacketDate", {
        get: function () {
            if (this.selectedCrop.value && this.plantingDate.value) {
                if (this.isWheatCrop && this.coldTreatmentDays != null) {
                    return addDays(this.plantingDate.value, this.averageDaysForSeedMaturity + (this.coldTreatmentDays.value * 7) + this.settings.NumberOfDaysInDormancy);
                }
                return addDays(this.plantingDate.value, this.averageDaysForSeedMaturity);
            }
            return addDays(this.plantingDate.value, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExperimentDetailsFormComponent.prototype, "isWheatCrop", {
        get: function () {
            return this.selectedCrop && this.selectedCrop.value === this.settings.wheatCropId;
        },
        enumerable: true,
        configurable: true
    });
    ExperimentDetailsFormComponent.prototype.ngOnInit = function () {
        var activeCeSites = this.ceRequestOptions.ceSites.filter(function (s) { return s.isActive; });
        if (activeCeSites.length === 1) {
            this.pmoProjects = null;
            this.experimentDetailsFormGroup.patchValue({
                ceSite: this.ceRequestOptions.ceSites.find(function (s) { return s.isActive; }).id
            });
        }
        if (this.requestDesign && (this.requestDesign.requestedSeed.length > 0 || this.requestDesign.numberOfSeedsPerCell !== 1)) {
            this.disableCropSelection = true;
        }
        else {
            this.disableCropSelection = null;
        }
        this.formatOptions();
        this.subscriptions();
    };
    ExperimentDetailsFormComponent.prototype.onProgramChange = function (programKey) {
        var _this = this;
        this.pmoProjects = null;
        this.experimentDetailsFormGroup.patchValue({
            pmoProject: null
        });
        if (programKey != null) {
            var selectedPmoProgram = this.ceRequestOptions
                .pmoPrograms
                .find(function (o) { return o.programKey === programKey; });
            var queryModel = {
                pmoProgramKey: selectedPmoProgram.programKey
            };
            this.pmoProgramService
                .getProjects(queryModel)
                .subscribe(function (p) {
                _this.pmoProjects = asEnumerable(p)
                    .Where(function (p) { return p.prismId !== 0; })
                    .Where(function (p) { return p.isActive; })
                    .Select(function (p) { return ({
                    id: p.projectKey,
                    display: p.pmoProjectName
                }); })
                    .ToArray();
            });
        }
    };
    return ExperimentDetailsFormComponent;
}());
export { ExperimentDetailsFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-details/experiment-details-form/experiment-details-form.component.ts.pre-build-optimizer.js